import React from "react";
import { NewGeneratedTokenBackground } from "../Accounts/PlatformPreferences/Component/styled";
import { Button, Icon, Typography } from "@plum-xoxo/admin-dsm";

const AuthenticationSuccess = (props) => {
  return (
    <div className="d-flex flex-column">
      <NewGeneratedTokenBackground className="justify-content-center align-items-center d-flex mb-16">
        <Icon
          iconName="PlumCheckbox"
          size="48"
          paddign="2px"
          color="green"
          shade="c300"
        />
      </NewGeneratedTokenBackground>
      <Typography.H3 color="dark" shade="c300">
        Authentication setup completed!
      </Typography.H3>
      <Typography.HelperText color="dark" shade="c200" className="mt-4">
        {props.type == 1 ? (
          <>
            From now on, whenever you sign in to your account, you will need to
            enter both your password and also an authentication code generated
            in your authenticator app.
          </>
        ) : (
          <>
            From now on, whenever you sign in to your account, you will need to
            enter both your password and also a verification code sent to your
            mobile number {props.phnNumber}.
          </>
        )}
      </Typography.HelperText>
      <div className="mt-32 d-flex">
        <div className="ml-auto">
          <Button onClick={props.onClose}>Done</Button>
        </div>
      </div>
    </div>
  );
};
export default AuthenticationSuccess;
